module.exports = __webpack_public_path__ + "static/kobe-4-3ec7df39636f31f3ba5a2897e467d428.jpg";